module.exports = __webpack_public_path__ + "assets/img/11_1794_big.82d68eef.jpg";